import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const VersionRemarksModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    submitted, addRemarksMode,
    // event handlers
    onSubmit, onCancelClick,
    //
    tag, ontagChange, tagError, settagError,
    remarks, onremarksChange, remarksError, setremarksError,
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Add Remarks'
        buttonLabel='Add'
        cancelLabel='Cancel'
        isOpen={addRemarksMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='tag' label='Version'
            required={true} maxLength={20} autoFocus={true}
            value={tag} onChange={ontagChange}
            error={tagError} setError={settagError}
        />
        <InputTextSF type='text' name='remarks' label='Remarks'
            required={true} maxLength={100} 
            value={remarks} onChange={onremarksChange}
            error={remarksError} setError={setremarksError}
        />
    </ModalFormUI>

export default VersionRemarksModalUI
